import React, { useEffect, useState } from "react";
import Axios from "axios";
import TextField from "@mui/material/TextField";
import Navbar from "./Navbar";
import { useParams, useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message, Spin } from "antd";

function EditCourse() {
  const [list, setList] = useState([]);
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    document.title = "Update Course";
  }, []);

  useEffect(() => {
    Axios.get("/api/course/readOneCourse/" + params.id, {
      withCredentials: true,
    }).then((response) => {
      setList(response.data.course);
    });
  }, []);

  const [course, setCourse] = useState(list.CourseName);
  const [courseError, setCourseError] = useState(false);
  const [price, setPrice] = useState(list.CourseValue);
  const [priceError, setPriceError] = useState(false);
  const [loading, setLoading] = useState(false);

  const addToList = () => {
    setPriceError(false);
    setCourseError(false);

    if (course === "") {
      setCourseError(true);
      return;
    }
    if (price === 0) {
      setPriceError(true);
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    Axios.put(
      "/api/course/modifyCourse/" + params.id,
      {
        CourseName: course,
        CourseValue: price,
      },
      config
    )
      .then(function (response) {
        message.success(" Updated successfully");
        setTimeout(function () {
          history.push("/courselist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Update Course" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "10px",
            fontSize: "25px",
          }}
        >
          {/* <h2>Update Course</h2> */}
        </div>
        <div className="row mt-3 mb-4 pr-3 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body " key={list._id}>
                <div className="row form-group  " style={{ padding: "10px" }}>
                  <div className="col-lg-6">
                    <TextField
                      defaultValue={list.CourseName}
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Course Name"
                      onChange={(e) => setCourse(e.target.value)}
                      error={courseError}
                    />
                  </div>

                  <div className="col-lg-6">
                    <TextField
                      defaultValue={list.CourseValue}
                      className="lead-fields"
                      required
                      fullWidth
                      type="number"
                      id="outlined-required"
                      label="Course Price"
                      onChange={(e) => setPrice(e.target.value)}
                      error={priceError}
                    />
                  </div>
                </div>

                <div
                  className="float-right pr-3"
                  style={{ paddingTop: "40px" }}
                >
                  {" "}
                  <button
                    onClick={addToList}
                    className="btn btn-primary add-button"
                  >
                    {" "}
                    Update Course{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditCourse;
